import { API } from 'core';
import { ServerRoute } from 'core/api';

export class CmePassportImpersonationService {
  public static async getImpersonationToken(email: string): Promise<string> {
    const route: ServerRoute = ServerRoute.forAction('Users', 'generate-cmepassport-token');
    return await API.post(route, JSON.stringify(email));
  }
}
